import Teaser from '../components/teaser';

class Default {
	beforeEnter(data) {
		const nextContainer = data.next.container;
		const id = $(nextContainer).data('entry-id');
		this.runGA();
		this.handleTheme(data);
		this.initTeasers(nextContainer);
		this.scrollToTop();
		window._header.handleActiveClass(id);
	}

	afterEnter(data) {
		window._header.closeNavigation();
	}

	beforeLeave(data) {}

	afterLeave(data) {}

	scrollToTop() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'instant',
		});
	}

	initTeasers = scope => {
		const $teasers = $(scope).find('[data-teaser="el"]');

		// for each teaser in teasers
		$teasers.each((index, el) => {
			// create new instance of teaser
			new Teaser($(el));
		});
	};

	handleTheme = ({ current, next }) => {
		const nextTheme = $(next.container).data('theme');
		const currentTheme = $(current.container).data('theme');

		if (nextTheme) {
			window._$html.addClass(nextTheme);
		}

		if (currentTheme) {
			window._$html.removeClass(currentTheme);
		}
	};

	runGA = () => {
		if (typeof gtag === 'function') {
			const path = window.location.href
				.replace(window.location.origin, '')
				.toLowerCase();
			gtag('js', new Date());
			gtag('config', 'G-PVTB9LE41E', {
				page_title: document.title,
				page_path: path,
			});
		}
	};
}

export default Default;
